import React, { Component } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import SignInFormContainer from '../signin/SignInFormContainer'
import FancyInput from '../signin/FancyInput'
import BlueButton from '../signin/BlueButton'
import FormBlock from '../signin/FormBlock'

const LegalDisclaimer = styled.div`
  width: 400px;
  text-align: center;
  font-size: 14px;
  margin-top: 20px;
`
const Header = styled.div`
  width: 400px;
  text-align: center;
  font-size: 28px;
  font-style: bold;
  margin-bottom: 20px;
  color: #1F8CEB;
`

class SignUpForm extends Component {
  handleSignUp = () => {
    let formIsValid = true
    const inputs = [
      this.nameInput,
      this.companyNameInput,
      this.emailInput,
      this.passwordInput,
    ]

    inputs.forEach((input) => {
      if (!input.state.valid) {
        formIsValid = false
        return
      }
      if (input.value() === '') {
        formIsValid = false
        input.setupValidState({
          valid: false,
          invalidMessage: 'This field is required'
        })
      }
    })

    if (formIsValid) {
      this.props.handleSignUp({
        fullName: this.nameInput.value(),
        companyName: this.companyNameInput.value(),
        signUpEmail: this.emailInput.value(),
        signUpPassword: this.passwordInput.value(),
      })
    }
  }

  render () {
    return (
      <div>
        <Header>Create your account</Header>
        <SignInFormContainer>
          <FormBlock marginTop={12} marginBottom={19}>
            <FancyInput
              placeholder='Full Name'
              ref={(input) => { this.nameInput = input }}
            />
          </FormBlock>
          <FormBlock marginTop={19} marginBottom={19}>
            <FancyInput
              placeholder='Company Name'
              ref={(input) => { this.companyNameInput = input }}
            />
          </FormBlock>
          <FormBlock marginTop={19} marginBottom={19}>
            <FancyInput
              placeholder='Work Email'
              ref={(input) => { this.emailInput = input }}
              onBlurValidation={value => validateEmail(value)}
              onBlurValidationMessage='That’s not a valid email address'
            />
          </FormBlock>
          <FormBlock marginTop={19} marginBottom={19}>
            <FancyInput
              placeholder='Password'
              type='password'
              ref={(input) => { this.passwordInput = input }}
            />
          </FormBlock>
          <FormBlock marginTop={42} marginBottom={0}>
            <BlueButton
              onClick={this.handleSignUp}
              text='Create Account'
              fontSize={15}
              width={237}
              height={42}
            />
          </FormBlock>
        </SignInFormContainer>
        <LegalDisclaimer>
          * By signing up, you agree to our <a>Terms of Use</a>, <a>Privacy Policy</a> and to receive Whimm emails, newsletters & updates.
        </LegalDisclaimer>
      </div>
    )
  }
}

SignUpForm.propTypes = {
  handleSignUp: PropTypes.func.isRequired,
}

export default SignUpForm

function validateEmail (email) {
  const re = new RegExp('[^@]+@[^@]+\\.[^@]+')
  return re.test(email)
}



// WEBPACK FOOTER //
// ./src/components/signin/SignUpForm.js